// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"6b88570a","111":"68937b18","164":"9de465df","166":"4ff09e21","250":"4f4ed5a2","332":"c5d0d6d4","356":"bb9fdd23","454":"f6a69304","540":"5fc38885","656":"eb1ee705","783":"0425780d","825":"ace298f1","869":"a83cd175"}[chunkId] + ".chunk.js";
};